import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TMerchantInfo, TOpenIdStatusResponse, TUserData } from 'authentication/models';
import { createSelector } from 'reselect';

import { RootState } from '../store';

const initialState: TOpenIdStatusResponse = { userAuthenticated: false };

export const globalSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    resetStore: (state) => {
      state = initialState;
      return state;
    },
    setUserInfo: (state, action: PayloadAction<TUserData | undefined>) => {
      state.userInfo = action.payload;
    },
    setMerchantInfo: (state, action: PayloadAction<TMerchantInfo | undefined>) => {
      state.merchantInfo = action.payload;
    },
  },
});

// Selectors
const getAuthenticationState = (state: RootState): TOpenIdStatusResponse => state.authentication;

export const getMerchantInfo = createSelector(
  getAuthenticationState,
  (authentication) => authentication.merchantInfo,
);
export const getUserInfo = createSelector(
  getAuthenticationState,
  (authentication) => authentication.userInfo,
);

const { actions, reducer } = globalSlice;

export const { resetStore: authenticationReset, setMerchantInfo, setUserInfo } = actions;

export default reducer;
